import React, { useState, useEffect, useCallback } from 'react'
import { useLocation, useParams } from "react-router-dom";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { actionTypes, useStateValue } from "./../../store";
import FotterMain from '../BaseComponents/FotterMain';
import Header from '../BaseComponents/Header';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import parse from 'html-react-parser';
import { getOEMProductDetails, getProductDetails } from '../../networkCalls';
import LoadingCellFullPage from '../LoadingCell/LoadingCellFullPage';
import ImageZoomCell from './ImageZoomCell';
import SEO from '../BaseComponents/SEO';
import ProductNotifyOEM from './ProductNotifyOEM';

const ProductDetailOEM = () => {

    const location = useLocation()
    const { productID } = useParams();
    const [loading, setLoading] = useState(false);
    const [qtyCheck, setQtyCheck] = useState(false);
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const [slider1, setSlider1] = useState(null);
    const [slider2, setSlider2] = useState(null);
    const [, dispatch] = useStateValue();

    useEffect(() => {
        setNav1(slider1);
        setNav2(slider2);
    });
    const settingsMain = {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        //autoplay: true,
        swipeToSlide: true,
        arrows: false,
        // dots: true,
        asNavFor: '.slider-nav',
        infinite: false,
        centerMode: false,
    };

    const settingsThumbs = {
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        arrows: true,
        centerMode: false,
        swipeToSlide: true,
        focusOnSelect: true,
        centerPadding: '10px',
        infinite: false,
    };


    const [noProductFound, setNoProductFound] = useState(false);
    const [productDetails, setProductDetails] = useState('');

    const pullProductData = () => {
        var data = new FormData();
        data.append('productSlug', productID);
        setLoading(true);
        getOEMProductDetails(data).then((res) => {
            console.log('res getOEMProductDetails', res)
            setLoading(false);
            setNoProductFound(false)
            switch (res.data.status) {
                case 1:
                    setProductDetails(res.data?.productDetails);
                    return true;
                case 0:
                    setNoProductFound(true)
                    break;
                default:
                    return;
            }
        })
    }

    useEffect(() => {
        pullProductData();
    }, []);

    return (
        <>
            <SEO
                title={productDetails?.productMetaTitle}
                description={productDetails?.productMetaDescriptopn}
                name="HIPP - Honda India Power"
                url={`https://www.hondaindiapower.com${location?.pathname}`}
                type='Website'
            />
            <div id='hi-product-theme' className="product-details-body oem_wrap_head">
                <Header />
                {loading ? <><LoadingCellFullPage /></> : <>
                    {noProductFound ? <><div>No Product Found</div></> : <>
                        <div className='innerpagebg pt-5 pb-5'>
                            <div className='container'>
                                <div className='vh-100'>
                                    <div className='w-100' >
                                        <div className='w-100 w-lg-72 w-md-100' style={{ float: 'left' }}>
                                            <div className='card mb-3'>
                                                <div className='row'>
                                                    <div className='col-lg-5 col-md-12 col-12'>
                                                        <div className="slider-wrapper">
                                                            <Slider
                                                                {...settingsMain}
                                                                asNavFor={nav2}
                                                                ref={slider => (setSlider1(slider))}
                                                            >
                                                                {productDetails && productDetails?.productImages?.map((slide, i) =>
                                                                    <ImageZoomCell key={i} slide={slide} />
                                                                )}
                                                            </Slider>
                                                            {productDetails && productDetails?.productImages?.length > 1 ? <>
                                                                <div className="thumbnail-slider-wrap mb-3">
                                                                    <Slider
                                                                        {...settingsThumbs}
                                                                        asNavFor={nav1}
                                                                        ref={
                                                                            slider => (
                                                                                setSlider2(slider)
                                                                            )
                                                                        }
                                                                    >
                                                                        {productDetails?.productImages?.map((slide, i) =>
                                                                            <div className="slick-slide" key={i}>
                                                                                <img className="slick-slide-image border" alt="" src={`${slide.image}?img=${slide.id}`} />
                                                                                {/* <img className="slick-slide-image" src={`https://picsum.photos/800/400?img=${slide.id}`} /> */}
                                                                            </div>
                                                                        )}
                                                                    </Slider>
                                                                </div>
                                                            </> : null}
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-7 col-md-12 col-12 ps-4 pe-4'>
                                                        <div className='pro_info mt-4'>
                                                            <h3 className='txtdgray mb-2 mt-4'>{productDetails?.productName}</h3>
                                                            {/* <p className='txtred'>{productDetails?.catLabel}</p> */}
                                                            <p>{productDetails?.shortDescription}</p>
                                                        </div>
                                                        <hr />
                                                        <div className='f13 fw500' style={{ lineHeight: '24px' }}>
                                                            <div><span className='text-primary'>Manufactured by: </span>{productDetails?.manufacture?.name}</div>
                                                            {productDetails?.manufacture?.address != '' ? <div><span className='text-primary'>Address:</span><br />{productDetails?.manufacture?.address}</div> : <></>}
                                                            {productDetails?.manufacture?.email != '' ? <><div>
                                                                <span className='text-primary'>Email: </span><a href={`mailto:${productDetails?.manufacture?.email}`} className='txtdgray'>{productDetails?.manufacture?.email}</a></div>
                                                            </> : <></>}
                                                            {productDetails?.manufacture?.contact != '' ? <><div><span className='text-primary'>Contact: </span>
                                                                <a href={`tel:${productDetails?.manufacture?.contact}`} className='txtdgray'>{productDetails?.manufacture?.contact}</a>
                                                            </div></> : <></>}
                                                            {productDetails?.manufacture?.website != '' ? <><div>
                                                                <span className='text-primary'>Website: </span>
                                                                    <a href={productDetails?.manufacture?.website} target='_blank' className='txtdgray'>{productDetails?.manufacture?.website}</a>
                                                                </div></> : <></>}
                                                        </div>
                                                        <div className='offer_info'>
                                                            <hr className='mb-0' />
                                                            {productDetails && productDetails?.productOffers?.length > 0 && productDetails?.productOffers?.map((itemin, key) => (
                                                                <div key={key}><LocalOfferIcon className='f16 me-2 text-success' />{itemin?.name} - (Coupon Code: {itemin?.code})<hr /></div>
                                                            ))}
                                                        </div>
                                                        <div className='d-flex mt-2 align-items-center'>
                                                            <div className='d-none'>{productDetails?.productBrandLogo ? <><img src={productDetails?.productBrandLogo} className='border p-1 me-2' style={{ width: '100px' }} /></> : <></>}</div>
                                                            <div>{productDetails?.productWarranty}</div>
                                                        </div>
                                                        <div className='me-3 mt-0 table-responsive mb-3'>
                                                            <div className="product-general-info">
                                                                {productDetails && productDetails?.productHighlight?.length > 0 && productDetails?.productHighlight?.map((itemin, key) => (
                                                                    <div className="single-general-info d-flex" key={key}>
                                                                        <div style={{ width: '32px' }}>
                                                                            {/* <img src={`${baseURL}images/no-charges.png`} style={{ width: '24px' }} alt="" /> */}
                                                                            <StarBorderIcon color='error' className='me-2' />
                                                                        </div>
                                                                        <div className="">
                                                                            <span className='fw-bold'>{itemin?.label}</span> {itemin?.value}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='w-100 w-lg-28 w-md-100' style={{ float: 'right' }}>
                                            <div className='card mb-3 ms-lg-2'>
                                                {productDetails?.price != '0.00' ? <>
                                                    <div className='product__info-body p-3 pt-4'>
                                                        <div className='d-flex align-items-center justify-content-between'>
                                                            <div className='product__price product__price--current'>
                                                                <CurrencyRupeeIcon className='fw-bold f20' />{productDetails?.price}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr className='mt-0' />
                                                </> : <>
                                                    <div className='product__info-body p-3 pt-0'>
                                                        <div className='d-flex align-items-center justify-content-between'>
                                                            <div className='product__price product__price--current'>
                                                               
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>}
                                                <div>
                                                    <div className='p-3 pt-1'>
                                                        <div className='product__info-body pb-1'>
                                                            <ProductNotifyOEM category={productDetails?.catLabel} subCatLabel={productDetails?.subCatLabel} mId={productDetails?.manufacture?.manufactureId} model={productDetails?.productName} />
                                                        </div>
                                                        {productDetails?.productPDF != '' ? <>
                                                            <div className='mt-3'><a href={productDetails?.productPDF} variant="outline-secondary" className="btn btn-primary btn-sm w-100 shadow-sm" target="_blank">Download Catalogue</a></div>
                                                        </> : <></>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='w-100' style={{ float: 'left' }}>
                                            {productDetails?.fullDescription ? <>
                                                <div className='card mb-3'>
                                                    <h3 className='p-3 mb-0 f16 fw-bold'>DESCRIPTION</h3>
                                                    <hr className='mb-1 mt-0' />
                                                    <div className='row'>
                                                        <div className='col-sm-12 f14'>
                                                            {/* <div className='p-3'>{productDetails?.fullDescription}</div> */}
                                                            <div className='p-3'>{parse(`${productDetails?.fullDescription}`)}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </> : <></>}
                                            {productDetails && productDetails?.productSpecification?.length > 0 ? <>
                                                <div className='card mb-3'>
                                                    <h3 className='p-3 mb-0 f16 fw-bold'>SPECIFICATIONS</h3>
                                                    <hr className='mb-1 mt-0' />
                                                    <div className='row'>
                                                        <div className='col-sm-12 f14'>
                                                            <div className='p-3'>
                                                                <div className='row'>
                                                                    <div className='col-sm-12'></div>
                                                                    <div className='col-sm-12'>
                                                                        {productDetails && productDetails?.productSpecification?.length > 0 && productDetails?.productSpecification?.map((itemin, key) => (
                                                                            <div key={key}>
                                                                                <div className='d-flex align-items-center mb-2'>
                                                                                    {itemin?.image != '' ? <>
                                                                                        <div className='me-2'><img src={itemin?.image} alt={itemin?.label} style={{ maxWidth: '38px' }} /></div>
                                                                                    </> : null}
                                                                                    <div className='fw-bold f16'> <span className='text-black'>{itemin?.label}</span></div>
                                                                                </div>
                                                                                <table className='table  table-striped table-hover f14'>
                                                                                    <tbody>
                                                                                        {itemin?.list && itemin?.list?.length > 0 && itemin?.list?.map((listitem, key) =>
                                                                                            <tr key={key}>
                                                                                                <td className='w-50'>{listitem?.label}</td>
                                                                                                <td>{listitem?.value}</td>
                                                                                            </tr>
                                                                                        )}
                                                                                    </tbody>
                                                                                </table>
                                                                                <hr />
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </> : <></>}
                                            {productDetails && productDetails?.productFeatures?.length > 0 ? <>
                                                <div className='card mb-3'>
                                                    <h3 className='p-3 mb-0 f16 fw-bold'>FEATURES</h3>
                                                    <hr className='mb-1 mt-0' />
                                                    <div className='row'>
                                                        <div className='col-sm-12 f14'>
                                                            <div className='p-3'>
                                                                <div className='row'>
                                                                    <div className='col-sm-12'></div>
                                                                    <div className='col-sm-12'>
                                                                        <table className='table table-sm table-striped table-hover f14'>
                                                                            <tbody>
                                                                                {productDetails && productDetails?.productFeatures?.length > 0 && productDetails?.productFeatures?.map((itemin, key) => (
                                                                                    <tr key={key}>
                                                                                        <td className='w-50'>{itemin?.label}:</td>
                                                                                        <td>{itemin?.value}</td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </> : <></>}
                                            {productDetails?.extraInfo ? <>
                                                <div className='card mb-3'>
                                                    <div className='row'>
                                                        <div className='col-sm-12 f14'>
                                                            {/* <div className='p-3'>{productDetails?.fullDescription}</div> */}
                                                            <div className='p-3'>{parse(`${productDetails?.extraInfo}`)}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </> : <></>}
                                            {productDetails && productDetails?.productFaqs?.length > 0 ? <>
                                                <div className='card mb-3'>
                                                    <h3 className='p-3 mb-0 f16 fw-bold'>FAQ</h3>
                                                    <hr className='mb-1 mt-0' />
                                                    <div className='row'>
                                                        <div className='col-sm-12 f14'>
                                                            <div className='p-3'>
                                                                <div className='row'>
                                                                    <div className='col-sm-12'></div>
                                                                    <div className='col-sm-12'>
                                                                        {productDetails && productDetails?.productFaqs?.length > 0 && productDetails?.productFaqs?.map((itemin, key) => (
                                                                            <div key={key}>
                                                                                <div className='d-flex'>
                                                                                    <div className='fw500 f14'>{itemin?.question}</div>
                                                                                </div>
                                                                                <div className='text-muted f14'>
                                                                                    {itemin?.answer}
                                                                                </div>
                                                                                <hr style={{ background: '#999' }} />
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </> : <></>}
                                            <p className='f12'><span className='txtHiPrimaryColor'>Disclaimer:</span> Due to continuous improvement in product on the basis of market feedback above specification are subject to change with out any prior notice. Please contact authorized dealer/distributor for latest specification.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>}
                    <div style={{ clear: 'both', height: '40px' }}></div>
                </>}
                <FotterMain />
            </div>
        </>

    )
}

export default ProductDetailOEM